/* é¥¼å¾ */
import {  Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { EventEmitter } from '@angular/core';
import { FcinputComponent } from '../fcinput';
import { Router } from '@angular/router';
@Component({
    selector: 'fc-chartpie',
    template: `
    <ngx-charts-pie-chart *ngIf="fcType==='default'"
        [view]="fcView"
        [scheme]="fcScheme"
        [results]="fcData"
        [legend]="_showLegend"
        [legendTitle]="fcLegendTitle"
        [explodeSlices]="_explodeSlices"
        [labels]="false"
        [doughnut]="_doughnut"
        [gradient]="_gradient"
        (select)="_select($event)"
        (activate)="_activate($event)"
        (deactivate)="_deactivate($event)">
    </ngx-charts-pie-chart>
    <ngx-charts-advanced-pie-chart *ngIf="false"
      [view]="fcView"
      [scheme]="fcScheme"
      [results]="fcData"
      [gradient]="_gradient"
      (select)="_select($event)"
      (activate)="_activate($event)"
      (deactivate)="_deactivate($event)">
    </ngx-charts-advanced-pie-chart>    
    `,
    styles: [`
    
    `]
})
export class FcchartpieComponent extends FcinputComponent {
     /**éç½®å¾è¡¨æ°æ®*/
    @Input()
    fcData: any[] = [];
     /**è§å¾å¤§å°,number[]å,å¦æä¸ä¼ ç»§æ¿ç¶çº§çå®½é«*/
    @Input()
    fcView: number[] = [];
     /**å¾è¡¨çèªå®ä¹é¢è²ãç¨äºè¦çç¹å®å¼çé¢è²*/
    @Input()
    fcScheme: any = { domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']};
     /** æ¾ç¤ºæéèxè½´*/
    @Input()
    fcShowXAxis: string;
    _showXAxis: boolean = true;
     /**æ¾ç¤ºæéèyè½´*/
    @Input()
    fcShowYAxis: string;
    _showYAxis: boolean = true;
     /**ç¨æ¸åå¡«ååç´ èä¸æ¯çº¯è²*/
    @Input()
    fcGradient: string;
    _gradient: boolean = false;
     /**æ¾ç¤ºæéèå¾ä¾*/
    @Input()
    fcShowLegend: string;
    _showLegend: boolean = true;
     /**å¾ä¾æ é¢*/
    @Input()
    fcLegendTitle: string = "";
     /** æ¾ç¤ºæéèxè½´æ ç­¾*/
    _showXAxisLabel: boolean = true;
     /** æ¾ç¤ºæéèyè½´æ ç­¾*/
    _showYAxisLabel: boolean = true;
     /**xè½´æ ç­¾æå­*/
    @Input()
    fcXAxisLabel: string;
     /**yè½´æ ç­¾æå­*/
    @Input()
    fcYAxisLabel: string;
     /**å¾è¡¨ç±»å,åæ¬é¥¼å½¢å¾'default',é«çº§é¥¼å¾'advanced',é¥¼å¾è¡¨'grid'*/
    @Input()
    fcType: string = 'default';
     /**é´é*/
    @Input()
    fcBarPadding: string;
    _barPadding: number = 8;
     /**ä½¿æ¯ä¸ªåççåå¾ä¸å¶å¼ææ¯ä¾*/
    @Input()
    fcExplodeSlices: string;
    _explodeSlices: boolean = true;
     /**æ¯å¦æ¾ç¤ºæ ç­¾*/
    @Input()
    fcShowLabel: string;
    _showLabels: boolean = false;
     /**æ¯å¦ç©ºå¿å,é»è®¤ç©ºå¿*/
    @Input()
    fcDoughnut: string;
    _doughnut: boolean = true;
    constructor(public provider: ProvidersService, private router: Router) {
        super(provider, 'fc-chartpie');
    }
    _afterParentInit() {
         /**æ¾ç¤ºæéèxè½´,é»è®¤æ¾ç¤ºxè½´*/
        if (this.fcShowXAxis === 'N') {
            this._showXAxis = false;
        } else {
            this._showXAxis = true;
        }
         /**æ¾ç¤ºæéèyè½´,é»è®¤æ¾ç¤ºyè½´*/
        if (this.fcShowYAxis === 'N') {
            this._showYAxis = false;
        } else {
            this._showYAxis = true;
        }
         /**æ¾ç¤ºæéèxè½´æ ç­¾ï¼é»è®¤æ¾ç¤ºxè½´æ ç­¾*/
        if (this.fcXAxisLabel !== undefined) {
            this._showXAxisLabel = true;
        } else {
            this._showXAxisLabel = false;
        }
         /**æ¾ç¤ºæéèyè½´æ ç­¾ï¼é»è®¤æ¾ç¤ºyè½´æ ç­¾*/
        if (this.fcYAxisLabel !== undefined) {
            this._showYAxisLabel = true;
        } else {
            this._showYAxisLabel = false;
        }
         /**æ¾ç¤ºæéèå¾ä¾,é»è®¤æ¾ç¤ºå¾å*/
        if (this.fcShowLegend === 'N') {
            this._showLegend = false;
        } else {
            this._showLegend = true;
        }
         /**ç¨æ¸åå¡«ååç´ èä¸æ¯çº¯è²*/
        if (this.fcGradient === 'Y') {
            this._gradient = true;
        } else {
            this._gradient = false;
        }
         /**é´é*/
        if (this.fcBarPadding !== undefined) {
            this._barPadding = Number(this.fcBarPadding);
        }
         /**ä½¿æ¯ä¸ªåççåå¾ä¸å¶å¼ææ¯ä¾*/
        if (this.fcExplodeSlices === 'N') {
            this._explodeSlices = false;
        } else {
            this._explodeSlices = true;
        }
         /**æ¯å¦æ¾ç¤ºæ ç­¾*/
        if (this.fcShowLabel === 'Y') {
            this._showLabels = true;
        } else {
            this._showLabels = false;
        }
         /**æ¯å¦åå*/
        if (this.fcDoughnut === 'N') {
            this._doughnut = false;
        } else {
            this._doughnut = true;
        }
    }
    /**
     * éä¸­ 
     * @param event 
     */
    _activate(event) {
        this.event('activate', event);
    }
    /**
     * åç´ æ¿æ´»äºä»¶ï¼é¼ æ è¾å¥ï¼
     * @param event 
     */
    _deactivate(event) {
        this.event('deactivate', event);
    }
    /**
     * åç´ åç¨äºä»¶ï¼é¼ æ ç¦»å¼ï¼
     * @param event 
     */
    _select(event) {
        this.event('select', event);
    }
}
